import React, { useState, useEffect, useCallback } from 'react';
// import { Link, MemoryRouter, Route } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
// import PaginationItem from '@mui/material/PaginationItem';
// import { useLocation } from 'react-router-dom';
// import Inventory from '../../components/Inventory';
import InventoryManagement from '../../components/InventoryManagement';
import DeviceAssetInformation from '../../components/DeviceAssetInformation';
import CreateGateway from '../../components/CreateGateway';
import useApi from '../../api/useApi';
import Notification from '../../components/Notification';
import '../../scrollbar.css';

function Table() {
  // const location = useLocation();
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(localStorage.user).organization.id;
  const [openCreate, setOpenCreate] = useState(false);
  const [openGateway, setOpenGateway] = useState(false);
  const [openCsv, setOpenCsv] = useState(false);
  const [onClose, setOnClose] = useState(false);
  const [selectedDevice, selectDevice] = useState('');
  const [selectedType, setSelectedType] = useState({ type: '' });
  const [{ isLoading, isError, data }, getData] = useApi();
  const [deviceData, setDeviceData] = useApi();
  const [devices, setDevices] = useState([]);
  const [state, deleteDevice] = useApi();
  const [action, setAction] = useState('');
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState();
  const [message, setMessage] = useState();
  const [formData, setFormData] = useState({ q: '', device_type: '', project_name: '', status: '' });
  const [filteredData, setFilteredData] = useState([]);
  const [stats, projectData] = useApi();
  const [project, setProject] = useState([]);
  const [bulkDevice, setBulkDevice] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const day = 1000 * 60 * 60 * 24;
  let itemsPerPage;
  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;
  const [pageCount, setpageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [searchFlag, setSearchFlag] = useState(false);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  useEffect(() => {
    user && getData(`/organization/${orgId}/devices?limit=${itemsPerPage}&page=${page}`, 'GET');
    user && projectData(`/organization/${orgId}/projects`, 'GET');
  }, []);

  useEffect(() => {
    if (formData.device_type === '') {
      user && getData(`/organization/${orgId}/devices?limit=${itemsPerPage}&page=${page}`, 'GET');
    } else {
      user &&
        getData(
          `/organization/${orgId}/devices?limit=${itemsPerPage}&deviceType=${formData.device_type}&page=${page}`,
          'GET'
        );
    }
  }, [page]);

  useEffect(() => {
    if (selectedType !== formData.device_type) {
      user &&
        getData(
          `/organization/${orgId}/devices?limit=${itemsPerPage}&deviceType=${formData.device_type}&page=1`,
          'GET'
        );
    }
    setPage(1);
    setpageCount('');
    setSelectedType({ type: formData.device_type });
  }, [formData.device_type]);

  useEffect(() => {
    if (!stats.isLoading && !stats.isError && stats.data) {
      setProject(stats.data.projects);
    }
  }, [stats.isLoading, stats.isError, stats.data]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setDevices(data.devices);
      let z = data.devices;

      if (formData.project_name) {
        z = z.filter((x) => x?.device?.project?.projectName === formData.project_name);
      }

      if (formData.device_type) {
        z = z.filter((x) => x?.device?.deviceType === formData.device_type);
      }

      if (formData.status) {
        z = z.filter((x) => x?.device?.isActive.toString() === formData.status);
      }

      if (z.length > 0) setFilteredData(z);
      else setFilteredData([]);
      if (page === 1) {
        const total = Math.ceil(data.count / itemsPerPage);
        setpageCount(total);
      }
    }
    if (isError) {
      setFilteredData([]);
      setType('error');
      setMessage('Unable to fetch Device Detail');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const toggleOpenCsv = () => {
    setOpenCsv((prev) => !prev);
  };

  const toggleOpenGateway = () => {
    setOpenGateway((prev) => !prev);
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const handleDelete = () => {
    deleteDevice(`/devices/assets`, 'DELETE', { device: bulkDevice });
  };

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setBulkDevice([]);
      getData(`/organization/${orgId}/devices?limit=${itemsPerPage}&page=${page}`, 'GET');
      setType('success');
      setOnClose(false);
      setMessage('Device Deleted Successfully');
      setNotification(!notification);
      refreshList();
    }
    if (state.isError) {
      setType('error');
      setMessage('Unable to delete Device Detail');
      setNotification(!notification);
    }
  }, [state]);

  useEffect(() => {
    if (!deviceData.isLoading && !deviceData.isError && deviceData.data) {
      const rows = [];
      const headerRows = ['DEVICE ID', 'DEVICE TYPE', 'PROJECT', 'STATUS', 'LAST_MODIFIED'];
      rows.push(headerRows);

      // iterate through rows of table
      for (let i = 0, row; (row = deviceData.data.devices[i]); i++) {
        // rows would be accessed using the "row" variable assigned in the for loop
        // Get each cell value/column from the row
        const column1 = row.device.id;
        const column2 = row.device.deviceType;
        const column3 = row?.device?.project?.projectName ? row?.device?.project?.projectName : '---';
        const column4 = row?.device?.isActive ? 'ACTIVE' : 'INACTIVE';
        const column5 = getTimeoffset(row?.device?.DeviceInfo?.updatedAt);

        /* add a new records in the array */
        rows.push([column1, column2, column3, column4, column5]);
      }
      let csvContent = 'data:text/csv;charset=utf-8,';

      /* add the column delimiter as comma(,) and each row splitted by new line character (\n) */
      rows.forEach(function (rowArray) {
        const row = rowArray.join(',');
        csvContent += `${row}\r\n`;
      });
      /* create a hidden <a> DOM node and set its download attribute */
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'Device_Report.csv');
      document.body.appendChild(link);
      /* download the data file named "Stock_Price_Report.csv" */
      link.click();
    }
  }, [deviceData]);

  useEffect(() => {
    if (devices.length <= 0) {
      return;
    }

    if (formData.device_type === '' && formData.project_name === '' && formData.status === '') {
      setFilteredData(devices);
    }
    let z = devices;

    if (formData.project_name) {
      z = z.filter((x) => x?.device?.project?.projectName === formData.project_name);
    }

    if (formData.device_type) {
      z = z.filter((x) => x?.device?.deviceType === formData.device_type);
    }

    if (formData.status) {
      z = z.filter((x) => x?.device?.isActive.toString() === formData.status);
    }
    if (z.length > 0) setFilteredData(z);
    else setFilteredData([]);
  }, [formData.q, formData.project_name, formData.status]);

  const refreshList = () => {
    setDeviceList([]);
    setBulkDevice([]);
    selectDevice('');
    getData(`/organization/${orgId}/devices?limit=${itemsPerPage}&page=${page}`, 'GET');
    // toggleOpenCreate();
  };
  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;
  };

  const downloadExcel = (tableID, filename = '') => {
    /* Get the HTML data using Element by Id */
    setDeviceData(`/organization/${orgId}/devices`, 'GET');
  };

  const searchData = () => {
    setSearchFlag(true);
    getData(`/search?type=device&searchItem=${formData.q}`, 'GET');
  };

  useEffect(() => {
    if (formData.q === '') {
      setSearchFlag(false);
      setPage(1);
      getData(`/organization/${orgId}/devices?limit=${itemsPerPage}&page=1`, 'GET');
    }
  }, [formData.q]);

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white w-3/12 px-2 text-sm block m-auto rounded-2xl relative">
            <span className="block font-bold border-b p-4 text-textBlue1">Delete Device</span>
            <img
              src="assets/img/Close.svg"
              className="absolute top-3 right-3 h-3 cursor-pointer"
              alt=""
              onClick={() => setOnClose(false)}
            />
            <span className="block text-center text-sm my-8" style={{ color: '#9B9B9B' }}>
              Do you want to deprovision {bulkDevice[0]}?
            </span>
            <div className="mb-6 font-bold float-right mr-8 w-2/3">
              {/* <div className="w-1/3" /> */}
              <div className="w-2/3 lg:flex sm:block">
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 mr-2 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center h-7"
                  onClick={() => {
                    setOnClose(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="mt-1 lg:mt-0 w-auto lg:w-max border px-8 py-4 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                  onClick={handleDelete}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {openCreate && (
        <DeviceAssetInformation
          handleClose={toggleOpenCreate}
          action={action}
          notification={createNotification}
          selectedDevice={selectedDevice}
          refreshList={() => refreshList()}
        />
      )}

      {openCsv && (
        <InventoryManagement
          handleClose={toggleOpenCsv}
          action={action}
          notification={createNotification}
          refreshList={() => refreshList()}
        />
      )}
      {openGateway && (
        <CreateGateway
          handleClose={toggleOpenGateway}
          action={action}
          notification={createNotification}
          selectedDevice={selectedDevice}
          refreshList={() => refreshList()}
        />
      )}

      <div
        className="m-8 fixed bg-white"
        style={{
          filter: openCreate && 'blur(2px)',
          boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
          borderRadius: '6px',
          left: '14%',
          right: '14%',
          width: '81%',
          height: '94vh',
        }}
      >
        <div className="z-50" style={{ height: '22vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-lg">Devices</span>

            <div className="block lg:flex mt-1 lg:mt-0">
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  downloadExcel('tblData');
                }}
              >
                REPORT
                <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCsv();
                }}
              >
                BULK UPLOAD(CSV)
                <img src="assets/img/Create.svg" className="h-2 ml-2 " alt="" />
              </button>
              <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 rounded-sm ml-3 flex justify-between items-center rounded-xl">
                <input
                  type="text"
                  placeholder="Search"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                  onKeyDown={(e) => {
                    if(e.which === 13) searchData();
                  }}
                />
                <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl" style={{ minWidth: '700px' }}>
          <div className="bg-white w-tableWidth m-auto mb-10">
            <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-8 py-2 flex w-full relative bg-primary text-white">
                <div className="py-1 text-left text-xs w-1/3">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.device_type}
                      name="device_type"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">DEVICE</option>
                      <option>BLE_TAG</option>
                      <option>CATM1_TAG</option>
                      <option>BLE_GW</option>
                    </select>
                  </div>
                </div>
                <div className="py-1 text-left text-xs w-1/3">
                  {' '}
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.project_name}
                      name="project_name"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">PROJECT</option>
                      {project.map((item) => (
                        <option key={item?.id}>{item?.projectName}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="py-1 text-left text-xs w-1/3">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#ffffff"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.status}
                      name="status"
                      className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                <div className="py-2.5 text-left text-xs w-1/3">LAST MODIFIED</div>
                <div className="py-2.5 text-left text-xs w-1/5">ACTIONS</div>
              </div>
            </div>
            {!isLoading ? (
              <div className="hideScroll" style={{ overflowY: 'scroll', height: '68vh' }}>
                <table id="tblData" className="w-full">
                  {filteredData.map((item, idx) => (
                    <tr
                      className="my-1 px-8 flex
                  relative hover:border-indigo-200 focus-within:border-indigo-200"
                      style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                    >
                      <td className="flex items-center text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/3">
                        {item?.deviceType === 'BLE_TAG' ? (
                          <img src="assets/img/Bluetooth.svg" className="h-5 mr-4" alt="" />
                        ) : null}
                        {item?.deviceType === 'CATM1_TAG' ? (
                          <img src="assets/img/Cellular.svg" className="h-5 mr-4" alt="" />
                        ) : null}
                        {item?.deviceType === 'BLE_GW' ? (
                          <img src="assets/img/Gateway.svg" className="h-4 mr-4" alt="" />
                        ) : null}
                        {item?.id}
                      </td>
                      <td className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/3">
                        {item?.deviceType !== 'BLE_GW' ? item?.project?.projectName : item?.GatewayInfo?.location}
                      </td>
                      <td
                        className={`text-${item?.isActive ? 'green-600' : 'red-600'
                          } py-2 pl-10 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/3`}
                      >
                        {item?.isActive ? 'Active' : 'Inactive'}
                      </td>
                      <td className="text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/3">
                        {item?.DeviceInfo !== null ? getTimeoffset(item?.DeviceInfo?.updatedAt) : getTimeoffset(item?.GatewayInfo?.updatedAt)}
                      </td>
                      <td className="flex text-role py-2 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-1/5">
                        {item?.isActive ? <img
                          src="assets/img/Add_Grey.svg"
                          className="h-5 pt-1 mr-3 "
                          alt=""
                        /> : <img
                          src="assets/img/Add_Blue.svg"
                          className="h-5 pt-1 mr-3"
                          alt=""
                          onClick={(e) => {
                            selectDevice(item?.id);
                            // &&
                            // (item?.isActive === false)
                            //  &&
                            // (item?.isActive === false)
                            if (item?.deviceType === 'BLE_TAG' || item?.deviceType === 'CATM1_TAG') {
                              toggleOpenCreate();
                            } else if (item?.deviceType === 'BLE_GW') {
                              // selectDevice(item?.id);
                              toggleOpenGateway();
                            }
                          }}
                        />
                        }
                        {item?.isActive ?
                          <img
                            src="assets/img/Delete_Blue.svg"
                            className="h-5 pt-1"
                            alt=""
                            onClick={() => {
                              setBulkDevice([item?.id || item?.device?.id]);
                              // if (item?.device?.isActive || item?.isActive) {
                              setOnClose(true);
                              // }
                            }}
                          /> :
                          <img
                            src="assets/img/Delete_Grey.svg"
                            className="h-5 pt-1"
                            alt=""
                          />
                        }
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
            {!searchFlag && <Pagination className="Pagination" count={pageCount} page={page} onChange={handleChange} variant="outlined" shape="rounded" />}
          </div>
        </div>
      </div>
    </>
  );
}

export default Table;
